import { Navigate } from "react-router-dom";
import { useApplication } from "../contexts/ApplicationContext";
import { ADMIN_ONLY, WITH_CLIENT_ACCESS } from "../utils/permissions";
import {
  SkeletonHeader,
  SkeletonKpiStrip,
  SkeletonTable,
} from "../components/crm/Skeletons";

/**
 * Barra telas restritas a certos papéis quando alguém digita a URL direto.
 *
 * O redirecionamento só acontece depois que o usuário carrega — antes disso o
 * papel ainda é o restrito por padrão e mandaria o admin embora sem motivo.
 *
 * Enquanto espera, mostra um ESQUELETO de página e não um spinner. A diferença
 * aparece em toda rota protegida (Métricas, Usuários, Pagamentos, Comunicados,
 * Acessos): a tela por baixo nunca chegava a renderizar o esqueleto dela,
 * porque esta guarda devolvia o spinner antes — e o resultado era que
 * justamente as telas mais pesadas eram as únicas sem esqueleto.
 *
 * A forma é genérica de propósito (cabeçalho + indicadores + tabela): daqui
 * não dá para saber qual tela vem, e essa é a estrutura que a maioria delas
 * tem. Assim que o papel resolve, a tela assume com o esqueleto próprio.
 */
const RequireRole = ({ roles = ADMIN_ONLY, children }) => {
  const { role, isLoadingUser } = useApplication();

  if (isLoadingUser) {
    return (
      <div className="space-y-4">
        <SkeletonHeader />
        <SkeletonKpiStrip count={4} />
        <SkeletonTable rows={6} cols={5} />
      </div>
    );
  }

  if (!roles.includes(role)) {
    // O operador não tem /clientes: mandá-lo para lá cairia nesta mesma guarda.
    return (
      <Navigate to={WITH_CLIENT_ACCESS.includes(role) ? "/clientes" : "/"} replace />
    );
  }

  return children;
};

export default RequireRole;
